import BaseProductSearchPageMixin from "@/modules/core/product/protected/BaseProductSearchPageMixin";
import SearchParametersEditor from "./MicroCreditProductSearchParametersEditor";
import service from "./MicroCreditProductService";

export default {
  mixins: [BaseProductSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "name",
            label: this.$t("product.fields.name"),
            sortBy: "name",
            onClick: ({ row }) => {
              this.$router.push({
                name: "MicroCreditProduct",
                params: { id: row.id }
              });
            }
          },
          {
            key: "provider",
            label: this.$t("product.fields.provider"),
            sortBy: "provider.companyName",
            value: ({ row }) => row.provider.companyName
          },
          {
            key: "minAmount",
            label: this.$t("microCreditProduct.fields.minAmount"),
            sortBy: "minAmount",
            value: ({ row }) => "€ " + this.$number2text(row.minAmount)
          },
          {
            key: "maxAmount",
            label: this.$t("microCreditProduct.fields.maxAmount"),
            sortBy: "maxAmount",
            value: ({ row }) => "€ " + this.$number2text(row.maxAmount)
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          */
        ];
      }
    }
  },

  methods: {
    getService() {
      return service;
    }
  }
};
